import { render, staticRenderFns } from "./OrderListOrder.vue?vue&type=template&id=c8ed600c&"
import script from "./OrderListOrder.vue?vue&type=script&lang=js&"
export * from "./OrderListOrder.vue?vue&type=script&lang=js&"
import style0 from "./OrderListOrder.vue?vue&type=style&index=0&id=c8ed600c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports